import { cva } from '@/styled-system/css';

export const calendarYearSelectInputRecipe = cva({
  base: {
    width: `calc({sizes.Calendar.YearSelect.button.width} + {spacing.Calendar.YearSelect.gap.select-toButton})`,
    opacity: '0',
    border: 'none',
    padding: 0,
    textStyle: 'body-bold',
    color: 'text.neutral',
    appearance: 'none',
    paddingInlineEnd:
      'calc({sizes.Calendar.YearSelect.button.width} + {spacing.Calendar.YearSelect.gap.select-toButton})',
    cursor: 'pointer',
    outline: {
      _focus: 'none',
      _focusVisible: 'none',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {
        '&:focus + button': {
          boxShadow: 'Calendar.YearSelect.Button.focus',
        },
      },
    },
  },
});
